<div class="checkout-container font-inter">
    <div class="top-section-content">
        <div class="top-section container">
            <div class="icon-title-container">
                <mat-icon svgIcon="arrowleft" class="left-arrow-icon" (click)="goBack()"></mat-icon>
                <span class="title font-poppins">Secure Checkout</span>
            </div>
            <p class="subtitle">Discover amazing toy blocks and sets for endless creativity</p>
        </div>
    </div>

    <div class="bottom-section-content">
        <div class="bottom-section container">
            <div class="left-container">
                <div class="address-list-container">
                    <p class="address-heading font-poppins">Select Delivery Address</p>
                    <div class="address-container">
                        <mat-radio-group [(ngModel)]="selectedAddress" (change)="onAddressChange(selectedAddress?.id!)">
                            @for (address of currentUserAddresses; track $index) {
                            <div class="address-details" [ngClass]="{ 'active-address': selectedAddress === address }">
                                <mat-radio-button [value]="address"></mat-radio-button>
                                <div class="address-info">
                                    <p class="customer-name">
                                        {{ address.name }} <span class="address-type">{{ address.addressType }}</span>
                                    </p>
                                    <p class="address">{{ address.address }}</p>
                                    <p class="city">{{ address.city }}, {{ address.state }}, {{ address.pincode }}</p>
                                    <p class="mobile">
                                        Mobile : {{ currentUser?.userMobileNumber || address.mobileNumber }}
                                    </p>
                                </div>
                            </div>
                            }
                        </mat-radio-group>
                    </div>

                    <button mat-flat-button class="btn-primary-gradient" (click)="AddNewAddress()">
                        <span class="plus-icon">+</span>&nbsp; {{ buttonText }}
                    </button>
                </div>

                <div class="coupon-section" *ngIf="availableCoupons.length">
                    <div class="coupon-top-section">
                        <div class="coupon-title-icon font-poppins">
                            <mat-icon svgIcon="giftbox" class="gift-icon"></mat-icon>
                            <p class="coupon-title">Apply Coupons</p>
                        </div>

                        <p class="view-coupon" (click)="toggleCouponshow()">
                            {{ showCoupons ? "Hide Coupons" : "View Coupons" }}
                        </p>
                    </div>

                    <div class="coupon-applied-container" *ngIf="appliedCoupon">
                        <div class="tick-save-container">
                            <div class="coupon-code-text-container">
                                <p class="coupon-code">{{ appliedCoupon.code }}</p>
                            </div>
                        </div>

                        <mat-icon class="close-icon" (click)="removeCoupon()">close</mat-icon>
                    </div>

                    @if (appliedCoupon) {
                    <p class="applied-coupon-message">Promocode Applied!</p>
                    }

                    <div class="coupons-container" *ngIf="showCoupons">
                        <div class="coupons">
                            @for (coupon of availableCoupons; track $index) {
                            <div class="coupon" [ngClass]="{ 'active-coupon': appliedCoupon?.id === coupon.id }">
                                <div class="coupon-code-button-container">
                                    <p class="save-text">SAVE</p>

                                    @if (appliedCoupon?.id === coupon.id) {
                                    <mat-icon svgIcon="tick" class="applied-icon"></mat-icon>
                                    }
                                </div>

                                <div class="coupon-code">{{ coupon.couponCode }}</div>

                                <div class="coupon-details-section">
                                    <p class="coupon-description">
                                        Get {{ coupon.discountPercentage }}% OFF up to {{ "currency.rs" | translate }}
                                        {{ coupon.maxAmount }}
                                    </p>
                                    <div class="min-purchase-valid">
                                        <p class="min-purchase" *ngIf="coupon.minPurchaseAmount">
                                            <mat-icon svgIcon="minpurchase" class="minpurchase-icon"></mat-icon>
                                            {{ "checkout.minPurchase" | translate }}
                                            {{ coupon.minPurchaseAmount | currency: "INR" }}
                                        </p>
                                        <p class="valid-upto">
                                            <mat-icon svgIcon="date" class="date-icon"></mat-icon>
                                            <span>{{ "checkout.validTill" | translate }}</span>
                                            <span>{{ coupon.validUpTo | date: "dd/MM/yyyy" }}</span>
                                        </p>
                                    </div>
                                    <p class="add-items" *ngIf="discountedTotal <= coupon?.minPurchaseAmount!">
                                        {{ "checkout.addMoreItem" | translate }}
                                    </p>

                                    <button
                                        mat-flat-button
                                        class="apply-coupon-btn"
                                        [disabled]="
                                            appliedCoupon?.id === coupon.id ||
                                            discountedTotal <= coupon?.minPurchaseAmount!
                                        "
                                        (click)="applyCoupon(coupon.couponCode)"
                                    >
                                        {{ appliedCoupon?.id === coupon.id ? "Applied" : "Apply" }}
                                        <mat-icon
                                            svgIcon="tick"
                                            class="applied-icon"
                                            iconPositionEnd
                                            *ngIf="appliedCoupon?.id === coupon.id"
                                        ></mat-icon>
                                    </button>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="right-container">
                <div class="delivery-icon-container">
                    <mat-icon svgIcon="freedelivery" class="delivery-icon"></mat-icon>
                    <p class="delivery-heading font-poppins">
                        {{ "addressList.label.deliveryEstimates" | translate }}
                    </p>
                </div>

                <div class="delivery-item-container">
                    @for (item of cartItems;let i = $index; track i) {
                    <div class="delivery-item">
                        <img
                            class="item-image"
                            [class]="'product-image-gradient' + ((i % 3) + 1)"
                            [src]="item.product?.images?.imagesUrl?.[0]"
                        />
                        <p class="estimate-text">Estimated Delivery between <span class="date">7 to 8 days</span></p>
                    </div>
                    }
                </div>

                <div class="separator"></div>

                <div class="price-detail">
                    <p class="price-detail-title font-poppins">Price Breakdown</p>
                    <p class="total-mrp">
                        <span>{{ "addressList.label.totalMrp" | translate }}</span
                        ><span>{{ totalMRP | currency: "INR" }}</span>
                    </p>
                    <p class="store-discount">
                        <span>{{ "addressList.label.discount" | translate }}</span
                        ><span class="store-discount-value">{{ storeDiscount | currency: "INR" }}</span>
                    </p>
                    <p class="total-discount">
                        <span>{{ "addressList.label.subTotal" | translate }}</span
                        ><span>{{ discountedTotal | currency: "INR" }}</span>
                    </p>
                    <p *ngIf="appliedCoupon" class="coupon">
                        <span>{{
                            isFirstUserCoupon()
                                ? ("checkout.firstUserCoupon" | translate)
                                : ("checkout.couponDiscount" | translate)
                        }}</span
                        ><span>{{ appliedCoupon.couponDiscount | currency: "INR" }}</span>
                    </p>
                    <p class="shipping">
                        <span>{{ "checkout.shipping" | translate }}</span
                        ><span class="shipping-value"
                            ><span *ngIf="deliveryCharge">{{ "currency.rs" | translate }}</span>
                            {{
                                deliveryCharge ? "+ " + ("currency.rs" | translate) + " " + deliveryCharge : "FREE"
                            }}</span
                        >
                    </p>
                    <div class="separator"></div>
                    <p class="total-discount">
                        <span class="total-amount">{{ "checkout.total" | translate }}</span
                        ><span class="total-amount-value">{{ total | currency: "INR" }}</span>
                    </p>
                    <p *ngIf="isUsingCoins" class="total-discount">
                        <span>{{ "checkout.coinsUsed" | translate }}</span
                        ><span>{{ coinsUsed | currency: "INR" }}</span>
                    </p>
                    <p *ngIf="isUsingCoins" class="total-discount">
                        <span>{{ "checkout.amountToBePaid" | translate }}</span
                        ><span>{{ amountToBePaid | currency: "INR" }}</span>
                    </p>
                    <div class="payment-details-row" *ngIf="storeDiscount || appliedCoupon || isUsingCoins">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon>
                        <span
                            >You will save
                            {{ storeDiscount + (appliedCoupon ? appliedCoupon.couponDiscount : 0) | currency: "INR" }}
                            on this order</span
                        >
                    </div>

                    @if (!isMoreOrEqualToMinOrderValue()) {
                    <p class="min-purchase-message">
                        {{ "checkout.minOrderAmount" | translate }}
                    </p>
                    }

                    <button
                        mat-flat-button
                        class="btn-primary-gradient"
                        [disabled]="!(currentUser && selectedAddress && isMoreOrEqualToMinOrderValue())"
                        (click)="openDialogForPayment()"
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
